<template>
  <ValidationProvider
    click-outside
    :name="name"
    :rules="required ? 'required|' : '' + 'location'"
    v-slot="{ errors }"
  >
    <v-text-field
      v-model="location"
      :name="name"
      :label="label"
      :error-messages="errors"
      @focus="displayMap()"
      @click="displayMap()"
      ref="input"
      @blur="automaticClose && !stillFocused && closeMap()"
    >
      <template v-slot:append>
        <v-btn
          @click="openModal()"
          small
          v-if="pickLocationManually"
          text
          color="primary pick-mobile-location"
        >
          Pick Location
        </v-btn>
        <v-icon
          v-else
          :title="`${dropdown ? 'close' : 'open'} map`"
          color="secondary"
          @click="markerClicked(e)"
        >
          $marker
        </v-icon>
      </template>
    </v-text-field>

    <div v-if="pickLocationManually">
      <portal to="modal-container">
        <div :id="pickLocation ? 'custom-map-modal' : ''">
          <transition name="component-fade" mode="out-in">
            <div
              v-if="pickLocation"
              class="custom-map-modal custom-modal dialog-right-transition"
            >
              <div class="caption position-absolute top left ml-20">
                <span>{{ getLocation() }}</span>
              </div>
              <v-btn
                elevation="2"
                fab
                top
                right
                small
                absolute
                class="mt-8 close-map"
                title="Close"
                @click="closeModal()"
              >
                X
              </v-btn>
              <MapBox
                :zoom="6"
                :showZoom="true"
                zoomControlPosition="top-left"
                :marker="isValid(value) ? value : center"
                @input="changeLocation"
                class="mt-3"
                :center="isValid(value) ? value : center"
                :editMode="true"
                @markerMoved="changeLocation"
              />
              <v-btn
                elevation="2"
                bottom
                center
                absolute
                class="mb-8 confirm-button"
                title="Confirm and proceed"
                @click="closeModal()"
              >
                Confirm
              </v-btn>
            </div>
          </transition>
        </div>
      </portal>
    </div>
    <div v-else class="map-container position-relative">
      <v-card
        class="map-card"
        v-if="dropdown"
        widht="100%"
        height="300px"
        @mouseover="stillFocused = true"
        @mouseleave="stillFocused = false && $refs.input.focus()"
      >
        <MapBox
          :zoom="6"
          :showZoom="true"
          :marker="isValid(value) ? value : center"
          @input="changeLocation"
          class="mt-3"
          :center="isValid(value) ? value : center"
          :editMode="true"
          @markerMoved="changeLocation"
        />
      </v-card>
    </div>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'LocationField',
  components: { MapBox: () => import('@components/utilities/MapBox') },
  props: {
    label: {
      type: String,
      default: 'Location',
    },
    name: {
      type: String,
      default: 'location',
    },
    required: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    pickLocationManually: {
      type: Boolean,
      default: false,
    },
    automaticClose: {
      type: Boolean,
      default: true,
    },
    center: {
      type: [Object],
      default: () => {
        return {
          lat: -3.5506035,
          lng: 120.632595,
        };
      },
      validator: function(center) {
        if (!center.lat && !center.lng) {
          throw new Error('provided center props is not valid!');
        }
        return true;
      },
    },
    value: {
      type: [Object, null],
      default: () => {
        return {
          lat: '',
          lng: '',
        };
      },
    },
  },
  data() {
    return {
      stillFocused: false,
      dropdown: false,
      location: this.getLocation(),
      marker: {},
      doNotSync: false,
      pickLocation: false,
    };
  },
  watch: {
    location() {
      this.syncLocation();
    },
    value() {
      this.doNotSync = true;
      this.location = this.getLocation();
    },
    pickLocation(val) {
      if (val) {
        document.body.classList.add('portalled');
      } else {
        document.body.classList.remove('portalled');
      }
    },
  },
  methods: {
    getLocation(location = this.value) {
      if (!location.lat || !location.lng) {
        return '';
      }
      return `${location.lat}, ${location.lng}`;
    },
    markerClicked(e) {
      e.preventDefault();
      e.stopPropagation();
      dropdown && this.closeMap();
    },
    displayMap() {
      this.dropdown = true;
    },
    openModal() {
      this.pickLocation = true;
    },
    closeModal() {
      this.pickLocation = false;
    },
    closeMap() {
      this.dropdown = false;
    },
    syncLocation(location = this.location) {
      location = location.replace(/ /g, '').split(',');
      if (location.length) {
        this.value.lat = location[0] || this.value.lat;
        if (location.length > 1) {
          this.value.lng = location[1] || this.value.lng;
        }
      }
    },
    changeLocation(location) {
      this.$emit('input', {
        ...this.value,
        ...location,
      });
    },
    isValid(location) {
      return location && (location.lat || location.lng);
    },
  },
  mounted() {
    if (!this.automaticClose) {
      this.displayMap();
    }
  },
};
</script>
<style scoped>
.map-container {
  height: 0;
  z-index: +1;
}
.map-card {
  position: absolute;
  width: 100%;
}
#custom-map-modal {
  z-index: +9999999999;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-map-modal {
  z-index: +9999999999;
  width: 100vw;
  height: 100vh;
  position: relative;
}
</style>
<style lang="scss">
.custom-map-modal {
  .caption {
    z-index: +9999999999999;
    color: white;
    font-size: 18px !important;
    margin-top: 18px;
    background: rgba(34, 89, 34, 0.7);
  }
  .mgl-map-wrapper.mt-3 {
    margin-top: 0 !important;
  }
  .confirm-button {
    left: 50%;
    transform: translateX(-50%);
  }
}
.map-card {
  position: relative !important;
}
.map-container {
  height: auto !important;
}
</style>
